import { formatCardNumber, getBrandCardIcon } from '../../utils';
import { Tag } from '../../_components';
import { formatPercentage } from 'src/utils/formatters';

import { useEventContext } from '../../provider';
import { useEventData, useEventHistory } from '../../hooks';
import { forwardRef } from 'react';
import { PaymentType, Uid } from 'src/types/dto';

import { PixIcon } from 'src/components/icons';

import { Button, ButtonProps, Icon, Box, Flex, Text } from '@chakra-ui/react';

import { useCheckoutFormValuesStore } from '../../stores';

import { useInstallments } from 'src/hooks/queries/useInstallments';

const CheckoutButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    return (
      <Button
        alignItems="center"
        bg='transparent'
        _hover={{bg: 'transparent'}}
        _focus={{bg: 'transparent'}}
        _active={{
          bg: 'transparent',
          '&> button' : {
              transform: "scale(0.95)",
              background: '#EBEBEB',
          }
        }}
        sx={{
          WebkitTapHighlightColor: "transparent",
        }}
        w="100%"
        h="46px"
        {...props}
        {...{ ref }}
      />
    );
  },
);

type Props = {
  eventId: Uid;
  taxCCPixDiff?: number;
};

export const PaymentMethodButton = ({ eventId, taxCCPixDiff }: Props) => {
  const eventHistory = useEventHistory();
  const event = useEventData();
  const { setInvalidFieldsNames, setInvalidFieldsMessage } = useEventContext();
  const { formValues } = useCheckoutFormValuesStore();
  const canPayWithPix = event?.paymentTypes.includes(PaymentType.Pix);

  const { maxInstallments } = useInstallments({
    sellId: formValues.sellId,
    eventID: event?.id,
    referral: '', 
  });
  const handleClickAddCard = () => {
    setInvalidFieldsNames?.([]);
    setInvalidFieldsMessage?.([]);
    eventHistory.push(`/event/${eventId}/checkout/payment-methods`);
  };

  if (formValues.selectedPaymentType === PaymentType.Pix) {
    return (
      <CheckoutButton onClick={handleClickAddCard}>
        <Box w="40px" mr="4">
          <PixIcon boxSize="6" color="#32bcad" />
        </Box>
        <Flex direction="column" align="flex-start">
          <Text color="black">PIX</Text>
          {!!taxCCPixDiff && (
            <Tag mt="1">{`${formatPercentage(taxCCPixDiff)} de Desconto`}</Tag>
          )}
        </Flex>
        <Button 
          fontSize={12} 
          h='73%' 
          bg='#F5F5F5' 
          px='1rem' 
          fontWeight='bold' 
          color="black" 
          ml="auto" 
          mr='-1rem'
          _hover={{bg: '#EBEBEB'}}
          _active={{
            transform: "scale(0.95)",
            background: '#EBEBEB',
        }}
        >
          Alterar
        </Button>
      </CheckoutButton>
    );
  }

  if (formValues.selectedPaymentType === PaymentType.CreditCard) {
    return (
      <CheckoutButton onClick={handleClickAddCard}>
        <Box w="40px" mr="4">
          <Icon
            color="black"
            boxSize="8"
            as={getBrandCardIcon(formValues.selectedCardBrand)}
            mr="4"
          />
        </Box>
        <Flex direction="column" align="flex-start">
          <Text color="black" mb="1">
            {formatCardNumber(formValues.selectedCardName)}
          </Text>
          <Text fontSize="sm" color="green.500">
            Parcele em até {maxInstallments}x
          </Text>
        </Flex>
        <Button 
          fontSize={12} 
          h='73%' 
          bg='#F5F5F5' 
          px='1rem' 
          fontWeight='bold' 
          color="black" 
          ml="auto" 
          mr='-1rem'
          _hover={{bg: '#EBEBEB'}}
          _active={{
            transform: "scale(0.95)",
            background: '#EBEBEB',
        }}
        >
          Alterar
        </Button>
      </CheckoutButton>
    );
  }

  return (
    <CheckoutButton onClick={handleClickAddCard}>
      <Flex direction="column" align="flex-start">
        <Text color="black">Escolher forma de pagamento</Text>
        {canPayWithPix && (
          <Flex align="center" color="green.500" fontSize="sm" mt="1">
            Obtenha desconto pagando por pix
          </Flex>
        )}
      </Flex>
      <Button 
          fontSize={12} 
          h='73%' 
          bg='#F5F5F5' 
          px='1rem' 
          fontWeight='bold' 
          color="black" 
          ml="auto" 
          mr='-1rem'
          _hover={{bg: '#EBEBEB'}}
          _active={{
            transform: "scale(0.95)",
            background: '#EBEBEB',
        }}
        >
          Alterar
        </Button>
    </CheckoutButton>
  );
};
